<template>
  <div ref="appContainer">
    <Header :style="{ 'padding-top': `${headerHeight}px` }"></Header>
    <Hero
        no-apply
        image="home.png"
        title="We are no longer taking new enquiries"
        leading="If you would like to explore a homeowner loan visit our group company Believe Loans"
    >
      <div class="believe-loans-cta">
        <img src="@/assets/logo-believe-loans.svg" class="logo" alt="Believe Loans Logo" />
        <div id="form-1" class="apply-button d-flex w-100 h-100 text-center justify-content-center p-0 m-0">
          <a href="https://www.believeloans.co.uk?utm_source=believe_finance&utm_medium=referral&utm_campaign=believe_finance_nltne"
             class="btn btn-xl btn-secondary align-middle d-flex flex-column align-items-center justify-content-center ctaButton m-3 p-3"
          >Visit Believe Loans</a>
        </div>
      </div>
    </Hero>
    <Footer no-button />
  </div>
</template>

<script>
import { Bus } from '../bus'

import Header from '../Sections/Header.vue'
import Hero from '../Sections/Hero.vue'
import Footer from '../Sections/Footer.vue'

export default {
  name: 'NoLongerTakingEnquiries',
  components: {
    Header,
    Hero,
    Footer
  },
  data() {
    return {
      height: 0
    }
  },
  computed: {
    headerHeight() {
      return this.height;
    }
  },
  created() {
    Bus.$on("headerHeight", (height) => {
      this.height = height;
    });
  },
  mounted() {
    window.addEventListener("message", event => {
      if (event.data.type === "scroll") {
        const iframePosition = document.getElementsByTagName('iframe')[0].getBoundingClientRect();
        event.data.offset -= this.height;
        if (event.data.offset < 0) {
          window.scrollTo(iframePosition.left, this.height);
          return;
        }
        const newScrollY =
            iframePosition.top + event.data.offset + window.scrollY;
        if (newScrollY < window.scrollY) {
          window.scrollTo(iframePosition.left, newScrollY);
        }
      }
    });
  }
}
</script>

<style>
.believe-loans-cta {
  margin-top:2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 1rem;
}
.believe-loans-cta .logo {
  max-width: 300px;

}
</style>
